import { UnitCategory } from "../SensorConfigurations/SensorConfigurationTypes.js";
import { UnitCategoryConfigurations } from "./UnitCategory/UnitCategoryConfigurations.js";

export const UNIT_PRESET_KEYS = ["CANADA", "USA", "VERDI_LEGACY"] as const;
export type UnitPresetKey = (typeof UNIT_PRESET_KEYS)[number];

export type UnitPreferences = {
    [K in UnitCategory]: (typeof UnitCategoryConfigurations)[K]["allowedUnits"][number];
};

export type UnitPreset = {
    key: UnitPresetKey;
    label: string;
    units: UnitPreferences;
};

export const UNIT_PRESETS = {
    CANADA: {
        key: "CANADA",
        label: "Canada (Metric)",
        units: {
            liquidFlow: "liters_per_minute",
            humidity: "percent_rh",
            airTemperature: "celsius",
            plantTemperature: "celsius",
            soilTemperature: "celsius",
            liquidPressure: "psi",
            volumetricSoilMoisture: "percent",
            resistiveSoilMoisture: "kilopascal",
            soilTension: "kilopascal",
            soilElectricalConductivity: "microsiemens_per_cm",
            windSpeed: "meters_per_second",
            windHeading: "degree",
            precipitation: "millimeter",
            liquidTankLevel: "percent",
            sapFlow: "liters_per_hour",
            stemWaterPotential: "kilopascal",
            electricalVoltage: "volt",
            evapotranspiration: "millimeter",
            electricalPulseCount: "pulse",
            soilVolumetricIonContent: "percent_vic",
            flowmeterKFactor: "liters_per_pulse",
            flowmeterOffset: "pulse_per_minute",
            flowmeterMinimumFrequency: "pulse_per_minute",
            pressureTransducerSlope: "kilopascal_per_volt",
            dimensionless: "dimensionless",
            arbitraryPercentage: "dimensionless",
            ndvi: "ndvi",
            ndviVariance: "ndvi",
            stemRadiusChange: "micrometer",
            solarRadiation: "watt_per_square_meter",
            depth: "meter",
        },
    },

    USA: {
        key: "USA",
        label: "USA (Imperial)",
        units: {
            liquidFlow: "gallons_per_minute",
            humidity: "percent_rh",
            airTemperature: "fahrenheit",
            plantTemperature: "fahrenheit",
            soilTemperature: "fahrenheit",
            liquidPressure: "psi",
            volumetricSoilMoisture: "percent",
            resistiveSoilMoisture: "kilopascal",
            soilTension: "kilopascal",
            soilElectricalConductivity: "microsiemens_per_cm",
            windSpeed: "miles_per_hour",
            windHeading: "degree",
            precipitation: "inch",
            liquidTankLevel: "percent",
            sapFlow: "gallons_per_hour",
            stemWaterPotential: "kilopascal",
            electricalVoltage: "volt",
            evapotranspiration: "inch",
            electricalPulseCount: "pulse",
            soilVolumetricIonContent: "percent_vic",
            flowmeterKFactor: "gallons_per_pulse",
            flowmeterOffset: "pulse_per_minute",
            flowmeterMinimumFrequency: "pulse_per_minute",
            pressureTransducerSlope: "kilopascal_per_volt",
            dimensionless: "dimensionless",
            arbitraryPercentage: "dimensionless",
            ndvi: "ndvi",
            ndviVariance: "ndvi",
            stemRadiusChange: "micrometer",
            solarRadiation: "watt_per_square_meter",
            depth: "inch",
        },
    },
    VERDI_LEGACY: {
        key: "VERDI_LEGACY",
        label: "Verdi Legacy",
        units: {
            liquidFlow: "liters_per_minute",
            humidity: "percent_rh",
            airTemperature: "celsius",
            plantTemperature: "celsius",
            soilTemperature: "celsius",
            liquidPressure: "psi",
            volumetricSoilMoisture: "percent",
            resistiveSoilMoisture: "kilopascal",
            soilElectricalConductivity: "microsiemens_per_cm",
            liquidTankLevel: "percent",
            stemWaterPotential: "kilopascal",
            electricalVoltage: "volt",
            electricalPulseCount: "pulse",
            soilTension: "kilopascal",
            windSpeed: "meters_per_second",
            windHeading: "degree",
            precipitation: "millimeter",
            sapFlow: "liters_per_hour",
            evapotranspiration: "millimeter",
            soilVolumetricIonContent: "percent_vic",
            flowmeterKFactor: "liters_per_pulse",
            flowmeterOffset: "pulse_per_minute",
            flowmeterMinimumFrequency: "pulse_per_minute",
            pressureTransducerSlope: "kilopascal_per_volt",
            dimensionless: "dimensionless",
            arbitraryPercentage: "dimensionless",
            ndvi: "ndvi",
            ndviVariance: "ndvi",
            stemRadiusChange: "micrometer",
            solarRadiation: "watt_per_square_meter",
            depth: "meter",
        },
    },
} satisfies Record<UnitPresetKey, UnitPreset>;
